import { Component, inject, Inject, ViewEncapsulation } from '@angular/core';
import {
  MAT_DIALOG_DATA,
  MatDialogContent,
  MatDialogTitle,
  MatDialogRef,
  MatDialog,
} from '@angular/material/dialog';
import { NgTemplateOutlet } from '@angular/common';
import { DialogModel } from '../../../interfaces/dialogs/dialog.model';
import { FormControl, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { companyNoValidator } from '../../../utils/validator.util';
import { TranslateService } from '@ngx-translate/core';
// import { CompanyCodeMappingService } from '../../../services/company-code-mapping.service';
import { ID_LOGIN_TYPE } from '../../../constants/common.constants';
import { SharedStorageService } from '../../../services/shared-storage.service';
import { AuthService } from '../../../services/auth.service';
import { SingleActionDialogComponent } from '../single-action-dialog/single-action-dialog.component';
import { Router } from '@angular/router';
import { VerifyEnterpriseService } from '../../../services/verify-enterprise.service';
import { MemberInfoResponse, ModifyInfoService } from '../../../services/modify-info.service';
import { STORAGE_KEY } from '../../../constants/store-key.constants';
/**
 * 共用dialog組件，傳入自訂title, message, TemplateRef
 */
@Component({
  selector: 'app-cta-dialog',
  standalone: true,
  imports: [MatDialogTitle, MatDialogContent, NgTemplateOutlet, FormsModule, ReactiveFormsModule],
  templateUrl: './cta-dialog.component.html',
  styleUrl: './cta-dialog.component.scss',
  encapsulation: ViewEncapsulation.None // 讓樣式可以作用到彈窗容器
})
export class CtaDialogComponent {
  constructor(
    public dialogRef: MatDialogRef<CtaDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: DialogModel,
    private dialog: MatDialog,
    // private companyCodeMappingService: CompanyCodeMappingService,
    private sharedStorageService: SharedStorageService,
    private authService: AuthService,
    private router: Router,
    private verifyEnterpriseService: VerifyEnterpriseService,
    private modifyInfoService: ModifyInfoService,

  ) {
    this.flowCode = this.sharedStorageService.get('myReservation')?.flowCode ?? '';

  }
    translateService: TranslateService = inject(TranslateService);
  flowCode: string
  isButtonDisabled = false;//預防多次點擊
  isFormSubmitted = false;
  enterpriseCodeControl = new FormControl('', [
    Validators.required,
    (control: FormControl) => companyNoValidator(control, this.translateService)
  ]);
  // 只有在表單提交後才顯示錯誤
  get hasError(): boolean {
    return this.enterpriseCodeControl.invalid && this.isFormSubmitted;
  }
  handleEnterpriseClick() {
    // 預防多次點擊
    this.dialogRef.close(true);
    if (this.isButtonDisabled || this.enterpriseCodeControl.invalid) {
      return;
    }

    const inputCode = this.enterpriseCodeControl.value?.trim() ?? '';

    // 將輸入的網路預約代碼轉換為公司代碼
    // const companyCode = this.companyCodeMappingService.convertWebCodeToCompanyCode(inputCode);



    this.isFormSubmitted = true;

    if (this.enterpriseCodeControl.valid) {
      // 檢查企業代碼格式
      if (this.enterpriseCodeControl.invalid) {
        this.enterpriseCodeControl.markAsTouched();
        return;
      }

      this.isButtonDisabled = true;
      // 設定預約類型為企業
      this.sharedStorageService.set('reserveType', ID_LOGIN_TYPE.ENTERPRISE);
      if (this.authService.isLogin() && this.sharedStorageService.get('loginStatus') === 'memberLogin') {
        if (this.flowCode === '4') {
          this.isButtonDisabled = false;
          const completeExamDialog = this.dialog.open(
            SingleActionDialogComponent,
            {
              data: {
                title: this.translateService.instant(
                  'id-login.login-already-reserved-dialog.title'
                ),
                message: this.translateService.instant(
                  'id-login.login-already-reserved-dialog.message'
                ),
                buttonText: this.translateService.instant(
                  'id-login.go-to-member-center'
                ),
                showCloseButton: true,
                closeAction: () => {
                  completeExamDialog.close();
                  this.router.navigate(['/']).then();
                },
                action: () => {
                  completeExamDialog.close();
                  this.router.navigate(['/healthcheck/member/mybooking']).then();
                },
              },
            }
          );
        } else {
          // 驗證企業資訊(CB-040) - 已登入
          this.verifyMemberEnterpriseInfo(this.enterpriseCodeControl.value?.trim() ?? '');
        }
      } else {
        // 驗證企業資訊(CB-040) - 未登入
        this.verifyNewEnterpriseInfo(this.enterpriseCodeControl.value?.trim() ?? '');
      }
    }
  }
  // 驗證企業資訊 (CB-040) - 已登入
  verifyMemberEnterpriseInfo(companyNo: string) {
    console.log('開始進入企業驗證，(已登入)');
    this.verifyEnterpriseService.verifyEnterpriseInfo(companyNo).subscribe({
      next: (res) => {
        if (res.statusCode === 'S0000') {
          // 是否超過企業可預約時間
          if (res.data?.isOverBookableDate === true) {
            const overBookableDateDialog = this.dialog.open(
              SingleActionDialogComponent,
              {
                disableClose: true,
                data: {
                  title: this.translateService.instant(
                    'business-login.company-code-error.title'
                  ),
                  message: this.translateService.instant(
                    'business-login.company-code-error.message'
                  ),
                  buttonText: this.translateService.instant(
                    'common.button.i-understood'
                  ),
                  showCloseButton: false,
                  closeAction: () => {
                    this.sharedStorageService.clear();
                    this.isButtonDisabled = false;
                    overBookableDateDialog.close();
                    return;
                  },
                  action: () => {
                    this.sharedStorageService.clear();
                    this.isButtonDisabled = false;
                    overBookableDateDialog.close();
                    return;
                  },
                },
              }
            );
          } else {
            this.isButtonDisabled = false;
            console.log('查詢成功');
            this.sharedStorageService.set('controlItem', res.data?.controlItem ?? 0);
            this.sharedStorageService.set('companyNo', companyNo);
            this.router.navigate(['/healthcheck/companylogin']).then();
          }
        } else {
          console.error('verifyEnterpriseInfo error:', res);
          // 查無企業資料
          if (res.statusCode === 'EL1007' || res.statusCode === 'EL1014') {
            this.sharedStorageService.clear();
            this.openNoEnterpriseDialog();
          }
          // 企業預約已到期
          // else if (res.statusCode === 'EL1013') {
          //   this.sharedStorageService.clear();
          //   // this.openNoEnterpriseDialog();
          // } 
          // 暫定先都回傳查不到企業代碼
          else {
            this.sharedStorageService.clear();
            this.openNoEnterpriseDialog();
          }
        }
      },
      error: (error) => {
        console.error('verifyEnterpriseInfo error:', error);
        const errorDialog = this.dialog.open(
          SingleActionDialogComponent,
          {
            disableClose: true,
            data: {
              title: this.translateService.instant('error.system-error'),
              buttonText: this.translateService.instant(
                'common.button.confirm'
              ),
              showCloseButton: true,
              closeAction: () => {
                this.sharedStorageService.clear();
                this.isButtonDisabled = false;
                errorDialog.close();
                return;
              },
              action: () => {
                this.sharedStorageService.clear();
                this.isButtonDisabled = false;
                errorDialog.close();
                return;
              },
            },
          }
        );
      }
    });
  }

  // 驗證企業資訊 (CB-040) - 未登入
  verifyNewEnterpriseInfo(companyNo: string) {
    console.log('開始進入企業驗證，(未登入)');
    this.verifyEnterpriseService.verifyEnterpriseInfo(companyNo).subscribe({
      next: (res) => {
        if (res.statusCode === 'S0000') {
          // 是否超過企業可預約時間
          if (res.data?.isOverBookableDate === true) {
            const overBookableDateDialog = this.dialog.open(
              SingleActionDialogComponent,
              {
                disableClose: true,
                data: {
                  title: this.translateService.instant(
                    'business-login.company-code-error.title'
                  ),
                  message: this.translateService.instant(
                    'business-login.company-code-error.message'
                  ),
                  buttonText: this.translateService.instant(
                    'common.button.i-understood'
                  ),
                  showCloseButton: false,
                  action: () => {
                    this.isButtonDisabled = false;
                    overBookableDateDialog.close();
                    return;
                  },
                },
              }
            );
          } else {
            this.isButtonDisabled = false;
            console.log('查詢成功');
            this.sharedStorageService.set('controlItem', res.data?.controlItem ?? 0);
            this.sharedStorageService.set('companyNo', companyNo);
            this.router.navigate(['/healthcheck/idlogin']).then();
          }
        } else {
          console.error('verifyEnterpriseInfo error:', res);
          // 查無企業資料
          if (res.statusCode === 'EL1007' || res.statusCode === 'EL1014') {
            console.log('查無企業資料');
            this.sharedStorageService.clear();
            this.openNoEnterpriseDialog();
          }
          // // 企業預約已到期
          // else if (res.statusCode === 'EL1013') {
          //   this.sharedStorageService.clear();
          //   // this.openNoEnterpriseDialog();
          // } 
          // 暫定先都回傳查不到企業代碼
          else {
            this.sharedStorageService.clear();
            this.openNoEnterpriseDialog();
          }
        }
      },
      error: (error) => {
        console.error('verifyEnterpriseInfo error:', error);
        const errorDialog = this.dialog.open(
          SingleActionDialogComponent,
          {
            disableClose: true,
            data: {
              title: this.translateService.instant('error.system-error'),
              buttonText: this.translateService.instant(
                'common.button.confirm'
              ),
              showCloseButton: true,
              closeAction: () => {
                this.isButtonDisabled = false;
                this.sharedStorageService.clear();
                errorDialog.close();
                return;
              },
              action: () => {
                this.isButtonDisabled = false;
                this.sharedStorageService.clear();
                errorDialog.close();
                return;
              },
            },
          }
        );
      }
    });
  }
  // 查無企業資料
  openNoEnterpriseDialog() {
    const noEnterpriseDialog = this.dialog.open(
      SingleActionDialogComponent,
      {
        disableClose: true,
        data: {
          title: this.translateService.instant(
            'error.company-code-error.error-title'
          ),
          message: this.translateService.instant(
            'error.company-code-error.message'
          ),
          buttonText: this.translateService.instant(
            'common.button.i-understood'
          ),
          showCloseButton: false,
          action: () => {
            this.sharedStorageService.clear();
            this.isButtonDisabled = false;
            noEnterpriseDialog.close();
            return;
          },
        },
      }
    );
  }

  onInputChange(event: Event) {
    const input = event.target as HTMLInputElement;
    const sanitizedValue = input.value.replace(/[^A-Za-z0-9-]/g, '').slice(0, 10); // 改成允許英文、數字和連字號

    // 同步更新 FormControl 的值
    if (this.enterpriseCodeControl.value !== sanitizedValue) {
      this.enterpriseCodeControl.setValue(sanitizedValue, { emitEvent: false });
    }

    // 清除錯誤狀態
    if (this.hasError) {
      this.isFormSubmitted = false;
    }

    // 重新驗證
    this.enterpriseCodeControl.updateValueAndValidity();
  }

  handlePersonalClick() {
this.dialogRef.close(true);
    // 標記即將進行個人健檢流程
    this.sharedStorageService.set('fromIdLogin', true);
    // 解決髒資料問題，若是已登入狀態
    if (this.sharedStorageService.get('loginStatus') === 'memberLogin') {
      this.modifyInfoService.getMemberInfo().subscribe({
        next: (res: MemberInfoResponse) => {

          // 髒資料由 interceptor 處理
          if (res.statusCode === 'S0000') {
            console.log('token有效，資料保留');
          }
        }
      });
    }

    // 設定預約類型為個人
    this.sharedStorageService.set('reserveType', ID_LOGIN_TYPE.PERSONAL);

    // 驗證 token 有效性
    this.authService.refreshSessions().subscribe(res => {
      console.log('refreshSessions success:', res);
      // EC6009 代表 token 過期
      if (res.statusCode === 'EC6009' || res.statusCode === 'E9028') {
        // token 過期，清除資料並重新登入
        console.log('token 過期，清除資料並重新登入');
        this.sharedStorageService.clear();
        this.sharedStorageService.remove('myReservation');
        this.authService.clearToken();
        this.router.navigate(['/healthcheck/idlogin']).then(res => { });
      }
      else if (this.authService.isLogin() && this.sharedStorageService.get('loginStatus') === 'memberLogin') {
        this.reservedBlocking('/healthcheck/reserve/location');
      } else {
        console.log('EC6007 未登入，導向idLogin');
        this.sharedStorageService.clear();
        this.sharedStorageService.remove('myReservation');
        this.authService.clearToken();
        this.router.navigate(['/healthcheck/idlogin']).then(res => { });
      }
    },
      (error) => {
        console.error('refreshSessions error:', error);
        this.sharedStorageService.clear();
        this.sharedStorageService.remove('myReservation');
        this.authService.clearToken();
        this.router.navigate(['/healthcheck/idlogin']).then(res => { });
      });

  }

  reservedBlocking(router: string) {
    if (this.flowCode === '4') {
      const completeExamDialog = this.dialog.open(
        SingleActionDialogComponent,
        {
          data: {
            title: this.translateService.instant(
              'id-login.login-already-reserved-dialog.title'
            ),
            message: this.translateService.instant(
              'id-login.login-already-reserved-dialog.message'
            ),
            buttonText: this.translateService.instant(
              'id-login.go-to-member-center'
            ),
            showCloseButton: true,
            closeAction: () => {
              completeExamDialog.close();
              this.router.navigate(['/']).then();
            },
            action: () => {
              completeExamDialog.close();
              this.router.navigate(['/healthcheck/member/mybooking']).then();
            },
          },
        }
      );
    } else {
      this.router.navigate([router]).then();
    }
  }

   handleQuickReserveClick() {
    this.dialogRef.close(true);
      // 設定預約類型為個人
      // 檢查環境配置，如果是 prod 環境則導向 not-available 頁面
      // 2026/2/2 打開prod
      this.sharedStorageService.set('reserveStep',  1); // 重置為步驟 1
      // const env = (window as any)?.env;
      // if (env?.environment === 'prod') {
      //   this.router.navigate(['/not-available']).then();
      //   return;
      // }
      this.sharedStorageService.set('reserveType', ID_LOGIN_TYPE.PERSONAL);
      const createMemberRequest = this.sharedStorageService.get('createMemberRequest');
      if (
        this.sharedStorageService.get(STORAGE_KEY.LOGIN_STATUS) !== 'memberLogin' &&
        !createMemberRequest?.idNo &&
        !this.authService.isLogin()
      ) {
        this.sharedStorageService.set(STORAGE_KEY.LOGIN_STATUS, 'newFriend');
      }
     this.reservedBlocking('/healthcheck/reserve/location');
    }
}
